import { UnorderedList as EvergreenUnorderedList } from "evergreen-ui";

const UnorderedList = ({ children, ...props }) => (
  <EvergreenUnorderedList listStyle="disc inside" {...props}>
    {children}
  </EvergreenUnorderedList>
);

export default UnorderedList;
